import React, { useEffect } from 'react'
import WelcomeBg from '../assets/images/banner-right-img.jpg'
import { useLocation, useNavigate } from 'react-router-dom';
import '../../src/commonstyle.css'
import { useDispatch, useSelector } from 'react-redux';
import CustomModal from '../components/common/CustomModal ';
import Button from '../components/common/ui/Button';
import { memo } from 'react';
import logo from '../assets/images/inmate-white-logo.png';
import { kioskLoginActions } from '../_store';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { PhotosActions } from '../_store/Photos.slice';
import Loader from '../components/common/Loader';
import { getStoredValue, getStoredMacIDValue } from "../../src/_helpers/storageHelper";
import CheckOffline from '../hooks/CheckOffline';

const WelcomePage = () => {
  const { loginDetails, KioskRestrictIntervalValidateResponse } = useSelector(state => state.kioskLogin);
  const storedLoginDetails = loginDetails?.FacilityID ? loginDetails : getStoredValue("loginDetails");
  const storedKioskRestrictIntervalValidate = getStoredValue("KioskRestrictIntervalValidate")
  const location = useLocation();
  const [showPopup, setshowPopup] = React.useState(location.state?.showPopup ? location.state?.showPopup : false);
  const [ConnectionStatus, setConnectionStatus] = React.useState();
  const [isShowpanel, setisShowpanel] = React.useState(!navigator.onLine);
  const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
  const [isLoading, setIsLoading] = React.useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (storedLoginDetails) {
      var Validate = await validateKioskRestrictInterval(storedLoginDetails, "Login")
      if (!Validate) return;
    }
    else {
      setisShowpanel(!navigator.onLine); localStorage.clear();
      // Cookies.remove('KIOKEY');
    }
    setIsLoading(true);
    const macId = getStoredMacIDValue('KIOKEY') || getStoredMacIDValue('MacId');
    if (macId) {
      dispatch(kioskLoginActions.getKiosksMacAddressValidate(macId)).then(x => {
        if (x?.payload) {
          setIsLoading(false);
          if (x?.payload.NoticeCount > 0) {
            navigate('/KioskNotice');
          } else {
            navigate('/Login');
          }
        }
        else {
          setIsLoading(false);
          navigate('/KioskSetup');
        }
      })
    }
    else {
      setIsLoading(false);
      navigate('/KioskSetup')
    }

  }

  const handleOkbtn = () => {
    setshowPopup(false);
    location.state = "";
    navigate('/');
  }

  const handlevalidate = (storedKioskRestrictIntervalValidate) => {
    if (storedKioskRestrictIntervalValidate?.IsKioskRestrictIntervalLock === 1) {
      setConnectionStatus("Kiosk locked for -" + storedKioskRestrictIntervalValidate?.KioskRestrictIntervalType);
      setisShowpanel(true);
      return;
    }
    else if (storedKioskRestrictIntervalValidate?.KiosksLockDownStatus === 1) {
      setConnectionStatus('Kiosks machine is locked. Please contact Administrator.');
      setisShowpanel(true);
      return;
    }
    else if (storedKioskRestrictIntervalValidate?.InmateLockDownStatus === 1) {
      setConnectionStatus('Inmate login restricted. please contact your facility admin');
      setisShowpanel(true);
      return;
    }
    else if (storedKioskRestrictIntervalValidate?.KiosksActiveStatus === 0 || storedKioskRestrictIntervalValidate?.PodActiveStatus === 0) {
      setConnectionStatus('Machine is Inactive, Please contact your Facility Admin.');
      setisShowpanel(true);
      return;
    }
    else {
      setisShowpanel(false);
    }
  }


  useEffect(() => {
    handlevalidate(storedKioskRestrictIntervalValidate);
  }, [storedKioskRestrictIntervalValidate?.PodActiveStatus, storedKioskRestrictIntervalValidate?.KiosksActiveStatus, storedKioskRestrictIntervalValidate?.IsKioskRestrictIntervalLock, storedKioskRestrictIntervalValidate?.KiosksLockDownStatus, storedKioskRestrictIntervalValidate?.InmateLockDownStatus])

  useEffect(() => {
    validateKioskRestrictInterval(storedLoginDetails);
  }, []);


  return (
    <div className="parent-container">
      {/* <CheckOffline/> */}
      <div className="form-column">
        {isShowpanel && <div className="connection-panel">
          <p className="connection-text">{ConnectionStatus}</p>
        </div>}
        <img className='image' src={logo} alt="Logo" onClick={() => { validateKioskRestrictInterval(storedLoginDetails) }} />
        <div className="app">
          <div className="row shadow-lg border-radius-all bg-dark overflow-hidden min-vh-55">
            <div className="col-md-6 bg-white p-5  d-flex flex-column justify-content-center">
              <p className="text-center mb-0 font-16">Welcome to</p>
              <h1 className="kiosk-title mb-2 text-nowrap">Inmate Inbox</h1>

              <p className="text-center font-size-18 font-500 mb-4">
                Send & Receive Secure Electronic Messages With Your Loved Ones
              </p>
              <div className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={handleSubmit}
                  label="LOGIN"
                  type="button"
                  status="primary"
                  disabled={false}
                />
              </div>
            </div>
            <div className="col-md-6 p-0 position-relative">
              <div className='overlay'></div>
              {/* <img src={LoginBg} alt="Inmate Inbox" className="img-fluid rounded-end w-100 h-100" /> */}
              <img src={WelcomeBg} alt="Inmate Inbox" className="img-fluid rounded-end w-100 h-100 welcomebg" />
            </div>
          </div>
        </div>
        {showPopup && (
          <CustomModal color={'#4a9a93'} content="Kiosk machine activated successfully" onOkClick={() => { handleOkbtn(); }} />
        )}
        {isLoading && <Loader />}
      </div>
    </div>

  )
}

export default memo(WelcomePage)